export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-100 rounded-3xl p-8 md:p-12 lg:p-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
              随时随地 刃牙漫画在线看
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              专为移动端优化的下拉式阅读体验，无论身在何处，打开手机浏览器即可畅享刃牙漫画免费在线阅读。无需下载APP，不占空间，即开即读。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-white rounded-full cursor-pointer whitespace-nowrap">
                <i className="ri-android-line text-lg"></i>
                <span className="text-sm font-medium">Android 网页版</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-white rounded-full cursor-pointer whitespace-nowrap">
                <i className="ri-apple-line text-lg"></i>
                <span className="text-sm font-medium">iOS 网页版</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[300px] md:max-w-[360px]">
            <div className="relative">
              <div className="aspect-[9/16] rounded-3xl overflow-hidden border-4 border-foreground-900/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20manga%20reading%20screen%20with%20warm%20red%20and%20dark%20theme%2C%20Japanese%20comic%20page%20layout%2C%20mobile%20reading%20interface%2C%20clean%20minimal%20UI%2C%20soft%20lighting%2C%20no%20text&width=720&height=1280&seq=app-01&orientation=portrait"
                  alt="刃牙漫画移动端阅读界面"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}